import styled from 'styled-components';
import Children from './children';

export default styled.li`
  position: relative;
  &:not(:hover) {
    ${Children} {
      display: none;
    }
  }
`;
